// src/api/org/service.js
import { json } from "utils/http/client";

export const ProjectApi = {
  // list sites by organization
  listSitesByOrganization: (organizationId) =>
    json(`/sites/organizations/${organizationId}/sites/`, { method: "GET" }),
  // get a site data by site Id
  getSiteById: (siteId) =>
    json(`/sites/get-a-sites/${siteId}/`, { method: "GET" }),

  // list members of a site
  listSiteMembers: (siteId) =>
    json(`/team/list-site-members/${siteId}/`, { method: "GET" }),

  listSitesByUser: () =>
    json(`/sites/list-users-sites/`, { method: "GET" }),

  updateSiteArchiveStatus: ({ siteId, activeFlag }) =>
    json(`/sites/update-sites/${siteId}/`, {
      method: "PATCH",
      body: { active_flag: activeFlag },
    }),

  getAllLocalBodyAdmin: () =>
    json(`/sites/get-all-localadminbody/`, { method: "GET" }),
  getAllSiteCategory: () =>
    json(`/sites/get-all-sitecatagory/`, { method: "GET" }),
  createSite: (data) =>
    json(`/sites/create-sites/`, { method: "POST", body: data }),
  deleteSite: (siteId) =>
    json(`/sites/delete-sites/${siteId}/`, { method: "DELETE" }),
};
